export const workAreaStatusOptions = [
  { name: 'Unscheduled', value: 0 },
  { name: 'Scheduled', value: 1 },
  { name: 'Waiting on Parts', value: 2 },
  { name: 'Completed', value: 3 },
]

export const workAreaStatusName = (status: number | null): string =>
  workAreaStatusOptions.find(x => x.value === status)?.name ?? ''

export const workAreaStatusNames = (statuses: number[]): string =>
  [...new Set(statuses ?? [])].map(workAreaStatusName).filter(Boolean).join(', ')
